jQuery(document).ready(function ($) {
    const addToCartModal = $('#add-to-cart-modal');

    function closeModal() {
        addToCartModal.addClass('hidden');
    }

    addToCartModal.find('#closeModalButton, #continueShoppingButton').on('click', function () {
        closeModal();

        const top = $('[data-product-calculator]').offset().top - $('#top').height();

        window.scroll({
            top: top,
            behavior: 'smooth',
        });
    });

    addToCartModal.on('click', function (event) {
        // Close modal when clicking outside of the modal
        if (event.target.id === 'add-to-cart-modal') {
            closeModal();
        }
    });

    $(document.body).on('added_to_cart', function (e, fragments) {
        if (!fragments || !fragments['div.widget_shopping_cart_content']) {
            return;
        }

        addToCartModal.removeClass('hidden');

        const miniCart = $(fragments['div.widget_shopping_cart_content']).find('.mini-cart');
        const cartTotal = miniCart.data('cartTotal');
        const cartContentsCount = miniCart.data('cartContentsCount');

        const formattedCartTotal = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
            useGrouping: false
        }).format(cartTotal);

        addToCartModal.find('#cart-total bdi').text(formattedCartTotal);
        addToCartModal.find('#cart-contents-count').text(cartContentsCount);
    });
});
